module.exports = __webpack_public_path__ + "static/media/news-black-book-2022.7ac951e9.jpg";